module.exports = __webpack_public_path__ + "static/assets/c429a0c638d1138c1f0b6ddac3491bad.png";